var map = {
	"./pages/charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts"
	],
	"./pages/chat/chat.module": [
		"./src/app/pages/chat/chat.module.ts"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"pages-dashboard-dashboard-module"
	],
	"./pages/drag-drop/drag-drop.module": [
		"./src/app/pages/drag-drop/drag-drop.module.ts"
	],
	"./pages/dynamic-menu/dynamic-menu.module": [
		"./src/app/pages/dynamic-menu/dynamic-menu.module.ts"
	],
	"./pages/form-controls/form-controls.module": [
		"./src/app/pages/form-controls/form-controls.module.ts"
	],
	"./pages/icons/icons.module": [
		"./src/app/pages/icons/icons.module.ts"
	],
	"./pages/landing/landing.module": [
		"./src/app/pages/landing/landing.module.ts"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts"
	],
	"./pages/mailbox/mailbox.module": [
		"./src/app/pages/mailbox/mailbox.module.ts"
	],
	"./pages/maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts"
	],
	"./pages/schedule/schedule.module": [
		"./src/app/pages/schedule/schedule.module.ts"
	],
	"./pages/tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts"
	],
	"./pages/ui/ui.module": [
		"./src/app/pages/ui/ui.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;